import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngxs/store';

import { CustomerState } from '@app/core/store/states/customer/customer.state';

export const canActivateScenarios: CanActivateFn = (route: ActivatedRouteSnapshot): UrlTree | boolean => {
  const customersHasNewGoalsPage = inject(Store).selectSnapshot(CustomerState.customersHasNewGoalsPage);

  return customersHasNewGoalsPage ? createUrlTreeFromSnapshot(route, ['/pg-goals'], route.queryParams) : true;
};
